import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { TemplateListingComponent } from './template-listing/template-listing.component';
import { TemplatesComponent } from './templates.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoModule } from "@jsverse/transloco";
import { AddNewTemplateComponent } from './add-new-template/add-new-template.component';
import { FiltersComponent } from './filters/filters.component';
import { TemplateTableComponent } from './template-table/template-table.component';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


const routes: Routes = [
  {
    path: '',
    component: TemplatesComponent,
    data: { animation: 'zoomIn' },
  },
];


@NgModule({
  declarations: [
    TemplateListingComponent,
    AddNewTemplateComponent,
    FiltersComponent,
    TemplateTableComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    NgbModule,
    CoreCommonModule,
    NgSelectModule,
    FormsModule,
    SharedModule,
    TranslocoDirective,
    TranslocoModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    NgxDatatableModule
  ],
  exports: [
    TemplateListingComponent,
    AddNewTemplateComponent,
    FiltersComponent,
    TemplateTableComponent
  ]
})
export class TemplatesModule {}
